// Constants used only by the Transcript feature.

// Zoom in-meeting chat message posted when transcription starts.
export const TRANSCRIPTION_START_CHAT_MESSAGE = `Review Amazon's Recording, Transcription, and Summarization Policy for permitted meeting types.
https://policy.a2z.com/docs/693659/publication

Notify attendees when meetings are being summarized or transcribed.

Meeting organizers are responsible for compliance. Refer to wiki for guidelines.
https://w.amazon.com/bin/view/UnifiedCommunications/MeetingSummaries/AiMS`;
